import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import { validateNumber } from "../../../utils/validateFields";
import EditDialog from "../../../Components/Common/EditDialog";
import { get, post } from "../../../utils/api";
import SelectField from "../../../Components/Masters/SelectField";
import { monthlist } from "../../../utils/constant";
import { useUser } from "../../../context/AuthContext";

function AddSocial({
  inputData,
  setAddData,
  addData,
  setsnackOpen,
  handleClose,
}) {
  const [errors, setErrors] = useState({});
  const { user } = useUser();
  const initialState = {
    module: "",
   
  };
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const startYear = currentYear - 5;
  const years = Array.from({ length: 6 }, (_, i) => startYear + i);

  const [formData, setFormData] = useState(initialState);
  const [formData2, setFormData2] = useState(initialState);
  const [editDialog, setEditDialog] = useState(false);

  const [filteredYears, setFilteredYears] = useState(years);
  const [disableValue, setDisableValue] = useState("");
  const [period, setPeriod] = useState([]);
  const [periodValue, setPeriodValue] = useState("");
  const [periodSelected, setPeriodSelected] = useState(false);
  const [hasPreviousEntries, setHasPreviousEntries] = useState(false);

 console.log(hasPreviousEntries,"formData");

  const validateForm = () => {
    const newErrors = {};
    const month = formData?.month;
    const year = formData?.year;
    if (!validateNumber(month)) newErrors["month"] = "Month is required";
    if (!validateNumber(year)) newErrors["year"] = "Year is required";
    if (
      periodSelected === true &&
      (!periodValue || periodValue === "")
    ) {
      newErrors["period"] = "Period value is required";
    }
    // setErrors(newErrors);
     setErrors((prevErrors) => {
    const updatedErrors = { ...prevErrors, ...newErrors };

    // Remove previous periodValue error if it’s now valid or not needed
    if (!newErrors["period"] && updatedErrors["period"]) {
      delete updatedErrors["period"];
    }

    return updatedErrors;
  });

    console.log(newErrors, "new1",periodSelected,periodValue);
    return Object.keys(newErrors).length === 0;
  };
useEffect(()=>{
},[periodSelected,periodValue])
  console.log(periodSelected,periodValue,"periodSelected,periodValue");
  const fetchData = useCallback(async () => {
    try {
      const response = await get(
        `/social/getSocial?type=Completed&companyId=${user?._id}`
      );
      const completed = response.data.data.filter(
        (item) => item.status === "Completed"
      );
      // Map to { value, label } for SelectField
      const periodOptions = completed.map((item) => ({
        id: item._id, // or any unique identifier
        label: item.title, // this will show the title in the dropdown
      }));
      console.log("periodOptions",response.data.data.length, periodOptions);
      setPeriod(periodOptions);
      setHasPreviousEntries((response.data.data || []).length > 0);
    } catch (error) {
      console.error("Error fetching data:", error);
      setHasPreviousEntries(false);
    }
  }, [user?._id]);

  useEffect(() => {
    fetchData();
  }, []);
  const Save = async () => {
    if (!validateForm()) return;
    try {
      const response = await post("/social/create", {
        ...formData,
        copyPrevious: periodSelected,
        sourceId: periodValue,
      });
      const message = response?.data?.message;
      console.log("response", response, message);
      setsnackOpen({
        open: true,
        message:
          message || "Report generation is in progress, Check after 10 mins.",
        severity: "success",
      });
      setFormData(initialState);
      setPeriodValue("");
      setPeriodSelected(false);
      handleClose();
    } catch (error) {
      console.log(error,"error",error.response.data.message);
      if ( error?.response?.data?.message) {
        const errorMessages = error.response.data.message
if(errorMessages.includes("already exists"))
  {
    setErrors({
      ...errors,
      year:errorMessages
    })
  }      
  //   setsnackOpen({
  //         open: true,
  //         message: errorMessages,
  //         severity: "error",
  //       });
  //       setFormData(initialState);
  //       setPeriodValue("");
  //       setPeriodSelected(false);
  //       handleClose();      } else {
  //       setsnackOpen({
  //         open: true,
  //         message: error.message || "An error occurred while saving the data.",
  //         severity: "error",
  //       });
      }
    }
  };

  const handleExitAgree = () => {
    setErrors({});
    setEditDialog(false);
    setFormData(initialState);
    setFormData2(initialState);
    handleClose();
  };

  const handleExit = () => {
    const isFormDataUnchanged = Object.keys(formData).every(
      (key) => formData[key] === formData2[key]
    );
    if (isFormDataUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true);
    }
  };

  const handleMonthChange = (event) => {
    setDisableValue("");
    setErrors && setErrors({ ...errors, month: "",year:"" });
    const selectedMonthIndex = event.target.value;
    setFormData({
      ...formData,
      month: selectedMonthIndex,
    });
    if (selectedMonthIndex > currentMonth + 1) {
      setDisableValue(currentYear);
      if (formData?.consumptionPeriod?.year === currentYear)
        setFormData({
          ...formData,
          year: "",
        });
    }
  };

  const handleYearChange = (event) => {
    setErrors && setErrors({ ...errors, year: "" });
    setFormData({
      ...formData,
      year: event.target.value,
    });
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{ width: "26rem", maxWidth: "100%", height: "100%" }}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleExit} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "88%", p: 3, backgroundColor: "#fff" }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          Social Entry
        </Typography>
        <Box>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", mb: "-0.5rem" }}
          >
            Month
          </Typography>
          <SelectField
            name={"Month"}
            value={formData?.month}
            handleChange={handleMonthChange}
            label="Month"
            field="month"
            errors={errors?.["month"] || ""}
            defaultValue={"Month"}
            options={monthlist}
          />
        </Box>

        {/* Year Input */}
        <Box>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", mb: "-0.5rem" }}
          >
            Year
          </Typography>
          <SelectField
            name={"Year"}
            value={formData?.year}
            handleChange={handleYearChange}
            options={filteredYears}
            errors={errors?.["year"] || ""}
            defaultValue={"Year"}
            menuDisable={disableValue}
          />
        </Box>
        {hasPreviousEntries && (
          <>
            <Box>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", mb: "-0.5rem" }}
              >
                Do You want to copy previous data?
              </Typography>
              <RadioGroup
                sx={{ display: "flex", flexDirection: "row", gap: "1rem" }}
                value={periodSelected ? "true" : "false"}
                onChange={(e) => {
                  setPeriodSelected(e.target.value === "true");
                  e.target.value === "false" && setPeriodValue("");
                }}
              >
                <FormControlLabel
                  value={"true"}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value={"false"}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </Box>
            {periodSelected === true && (
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bold", mb: "-0.5rem" }}
                >
                  Period
                </Typography>
                <SelectField
                  name="label"
                  value={periodValue}
                  handleChange={(e) => {
                    setPeriodValue(e.target.value);
                    setErrors((prev)=>({
                      ...prev,
                      ["period"]:""
                    }))
                  }}
                  options={period}
                  errors={errors?.["period"] || ""}
                  defaultValue={"Select"}
                  menuDisable={disableValue}
                />
              </Box>
            )}
          </>
        )}

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100%",
          minHeight: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleExit}
    >
      {list()}
    </Drawer>
  );
}

export default AddSocial;
